var render = function (_h,_vm) {var _c=_vm._c;return _c('v-content',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }